import axiosInstance from '../config/axiosInstance';

export interface AppNotification {
    id: string;
    type: string;
    message: string;
    relatedEntryId: string | null;
    relatedDate: string | null;
    relatedUserId: string | null;
    isRead: boolean;
    createdAt: string;
}

const notificationService = {
    async getMyNotifications(): Promise<AppNotification[]> {
        const response = await axiosInstance.get('/notifications/me');
        return response.data;
    },

    async getUnreadCount(): Promise<number> {
        const response = await axiosInstance.get('/notifications/me/unread-count');
        return response.data.count;
    },

    async markAsRead(id: string): Promise<AppNotification> {
        const response = await axiosInstance.patch(`/notifications/${id}/read`);
        return response.data;
    },

    async markAllRead(): Promise<void> {
        await axiosInstance.patch('/notifications/me/read-all');
    },
};

export default notificationService;
